// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { socialLinksStyles } from "@sc/Overrides/Widgets/Basic/SocialLinks";
import { css } from "styled-components";

socialLinksStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    `,
};

socialLinksStyles.linkWrapper = {
    css: css`
        margin-right: 2px;
        display: inline-flex;
    `,
};

socialLinksStyles.link = {
    typographyProps: {
        color: "common.ui",
    },
};
